// クライアントタイプ
export const CLIENT_TYPE = 'elcompath_map';

export const REACT_APP_ENVIRONMENT = process.env
  .REACT_APP_ENVIRONMENT as string;

export const REACT_APP_AUTH_INFO = process.env.REACT_APP_AUTH_INFO as string;

export const REACT_APP_SERVICE_ID = process.env.REACT_APP_SERVICE_ID as string;

export const REACT_APP_SERVICE_KEY = process.env
  .REACT_APP_SERVICE_KEY as string;

export const REACT_APP_CUCON_API_DOMAIN = process.env
  .REACT_APP_CUCON_API_DOMAIN as string;

export const REACT_APP_CUCON_OIDC_DOMAIN = process.env
  .REACT_APP_CUCON_OIDC_DOMAIN as string;

export const REACT_APP_CUCON_OIDC_MYPAGE = process.env
  .REACT_APP_CUCON_OIDC_MYPAGE as string;

export const REACT_APP_CUCON_MAP_RS_BASE_URL = process.env
  .REACT_APP_CUCON_MAP_RS_BASE_URL as string;

export const COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION as string;

export const S3_BUCKET_NAME = process.env.REACT_APP_S3_BUCKET_NAME as string;

export const S3_REGION = 'ap-northeast-1';

export const S3_OBJECT_URL_PREFIX = `https://${S3_BUCKET_NAME}.s3.${S3_REGION}.amazonaws.com`;

export const REACT_APP_SLACK_BOT_URL = process.env
  .REACT_APP_SLACK_BOT_URL as string;

export const PKCE_VERIFIER_KEY = 'pkce_verifier';

export const STATE_KEY = 'pkce_state';

export const NONCE_KEY = 'nonce';

export const SIGNIN_BACK_PATH = 'signin-back';
